const UserIndexReducer = (state = null, action) => {
  switch (action.type) {
    case 'ACTUAL_INDEX':
      return action.data
    default:
      return state
  }
}

export default UserIndexReducer
